import { ApplicationState } from './types/application-state';

export type StateTester = {
  (prevState: ApplicationState, nextState?: ApplicationState): any;
  desc?: string;
};

export type Case<T> = [StateTester, T];

type CurriedMatchFn = <T>(
  prevState: ApplicationState,
  nextState?: ApplicationState
) => (...cases: Case<T>[]) => (defaultResult: T) => T;

type CurriedMatchAllFn = <T>(...cases: Case<T>[]) => Array<T>;

/**
 * (state) => (...cases) => (default) => result
 */
export const match: CurriedMatchFn = <T>(
  prevState: ApplicationState,
  nextState?: ApplicationState
) => (...cases: Case<T>[]) => (defaultResult: T) => {
  const res = cases.find(([tester]) => tester(prevState, nextState));
  return res ? res[1] : defaultResult;
};

/**
 * (state) => (cases) => [...results]
 */
// eslint-disable-next-line
export const matchAll = <T>(
  prevState: ApplicationState,
  nextState?: ApplicationState
): CurriedMatchAllFn => <t>(...cases: Case<t>[]) => {
  const res = cases.filter(([tester]) => tester(prevState, nextState));
  return res.map(([, action]) => action);
};
